import styled from "styled-components"
import { theme } from "../../../../theme"
import { TableRow } from "@mui/material"

export const THeadRow = styled(TableRow)`
  color: ${theme.color.grey2};
`
